import { forwardRef } from "react";
function SvgChallengesActivityRawIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={20}
        height={23.001}
        x={0.5}
        y={0.5}
        fill="#fff"
        stroke="#DDD"
        rx={1.5}
      />
      <path
        fill="#E7F1FF"
        d="M1.5 2.5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1V9h-18V2.5Z"
      />
      <path
        fill="#959595"
        d="M3 6.5h12a2 2 0 0 1 2 2v4H3v-6ZM3 14.501a.5.5 0 0 1 .5-.5h11a.5.5 0 1 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
      />
      <path
        fill="#333"
        d="M3 4a.5.5 0 0 1 .5-.5H15a.5.5 0 1 1 0 1H3.5A.5.5 0 0 1 3 4Z"
      />
      <path
        fill="#959595"
        d="M3 17a.5.5 0 0 1 .5-.5h11a.5.5 0 1 1 0 1h-11A.5.5 0 0 1 3 17ZM3 19.502a.5.5 0 0 1 .5-.5h12a.5.5 0 1 1 0 1h-12a.5.5 0 0 1-.5-.5Z"
      />
      <circle
        cx={19.002}
        cy={15.5}
        r={5}
        fill="#fff"
        stroke="#DDD"
        strokeWidth={2}
      />
      <path
        fill="#106FF3"
        fillRule="evenodd"
        d="M19.003 20.337a4.836 4.836 0 1 0 0-9.672 4.836 4.836 0 0 0 0 9.672Zm1.926-6.454a.5.5 0 1 0-.874-.486l-1.486 2.674-.653-.87a.5.5 0 0 0-.8.6l1.116 1.487a.5.5 0 0 0 .837-.057l1.86-3.348Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChallengesActivityRawIcon);
export default ForwardRef;
